import React, { Component } from 'react';
import PropTypes from 'prop-types';

import style from './index.module.scss';

const questions = [
  {
    title: 'How does being black in Canada differ from being black in the US?',
    views: 618632,
    shares: 212,
    followers: 309,
  },
  {
    title:
      'How much would Tutankhamun’s death mask cost if it were put up for sale?',
    views: 564878,
    shares: 53,
    followers: 111,
  },
  {
    title: 'Would you switch races if it were possible?',
    views: 20978,
    shares: 32,
    followers: 37,
  },
  {
    title: 'How much damage can a human body take?',
    views: 5911,
    shares: 18,
    followers: 12,
  },
  {
    title:
      'What are the differences between a supergiant star and a hypergiant star?',
    views: 7654,
    shares: 5,
    followers: 27,
  },
  {
    title: 'Why, in 2016, is hunger still a major issue in the world?',
    views: 4098,
    shares: 17,
    followers: 19,
  },
  { title: 'Am I lactose intolerant?', views: 2109, shares: 7, followers: 16 },
  {
    title: "What is the worst thing you've ever come across on the Internet?",
    views: 3557,
    shares: 2,
    followers: 5,
  },
  {
    title: 'What happens to ISIL/Daesh if the Iraqi troops retake Mosul?',
    views: 1543,
    shares: 13,
    followers: 9,
  },
  {
    title: 'Has Quora thought about creating platforms for other languages?',
    views: 818,
    shares: 2,
    followers: 10,
  },
  {
    title:
      'How does hunting affect conservations efforts (in developing countries)?',
    views: 200,
    shares: 0,
    followers: 2,
  },
];

const answers = [
  {
    title: 'How do animals without hands deal with quills from a porcupine?',
    views: 87117,
    shares: 112,
    upvotes: 1685,
  },
  {
    title: 'Which millionaire/billionaire literally came from nothing?',
    views: 63921,
    shares: 87,
    upvotes: 872,
  },
  {
    title: "Is it abnormal that I've never dated before at 24 years old?",
    views: 21342,
    shares: 12,
    upvotes: 465,
  },
  {
    title: 'Should the African Cup of Nations be switched to June/July?',
    views: 18765,
    shares: 23,
    upvotes: 321,
  },
  {
    title:
      'Despite being a proven goal scorer, why is Olivier Giroud always placed on the bench by Wenger?',
    views: 9008,
    shares: 65,
    upvotes: 202,
  },
  {
    title:
      'Uber wants a valid zip code but my country doesnt use zip codes. How can I sign up?',
    views: 12509,
    shares: 15,
    upvotes: 76,
  },
  {
    title: 'Which IDE or text editor are you using right now? Why?',
    views: 8701,
    shares: 22,
    upvotes: 121,
  },
  {
    title:
      "Would you willingly become homeless for 24 hours if you'd get paid $150,000? You have nothing and you’re on your own during this time, with the exception of money/food you’d get from begging from strangers.",
    views: 1643,
    shares: 5,
    upvotes: 34,
  },
  {
    title: 'Be honest, what do you think of when you hear "black people"?',
    views: 4008,
    shares: 7,
    upvotes: 59,
  },
  {
    title:
      'If "blackface" is considered racist and offensive, why isn\'t "whiteface"?',
    views: 2342,
    shares: 0,
    upvotes: 43,
  },
  {
    title:
      "What's the difference between conservatives watching FOX News and liberals watching CBS/NBC/ABC/CNN/MSNBC news? Why are liberal biased stations okay but not conservative ones?",
    views: 867,
    shares: 3,
    upvotes: 6,
  },
];

class StatsMain extends Component {
  state = {
    answers,
    questions,
    isActive: false,
  };

  // Show stats corresponding to specific question/answer
  onShowSpecificStats = index => {
    this.setState({
      isActive: true,
    });
  };

  // If number is >= 1000 user k to represent 1000
  formatStat = number => {
    if (number >= 1000) return `${Math.round(number / 1000)}k`;
    return number;
  };

  // Total for corresponding all-time questions/answers stats
  total = (statsArr, prop) =>
    statsArr.reduce((total, stat) => total + stat[prop], 0);

  render() {
    const { questions, answers } = this.state;
    const { categoryOption } = this.props;

    return (
      <table className={`table ${style.main}`}>
        <tbody>
          <tr className='row'>
            <td className={`col-5 ${style['col-title']}`}>
              <div>
                <table className='table'>
                  <tbody>
                    {categoryOption === 'answers' ? (
                      <>
                        <tr>
                          <td className={style['title-header']}>
                            <p>All questions</p>
                            <span>
                              <i className='fas fa-check' />
                            </span>
                          </td>
                        </tr>
                        {questions.map((question, index) => (
                          <tr key={index}>
                            <td className={style['question-title']}>
                              <p>{question.title}</p>
                              <span>
                                <i className='fas fa-check' />
                              </span>
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td className={style['title-header']}>All answers</td>
                        </tr>
                        {answers.map((answer, index) => (
                          <tr key={index}>
                            <td>{answer.title}</td>
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </td>
            <td className={`col-7 ${style['col-stats']}`}>
              <div className='row'>
                {categoryOption === 'questions' ? (
                  <>
                    <div className={`col-4 ${style.stat}`}>
                      <p className={style['stat-value']}>
                        {this.formatStat(this.total(questions, 'views'))}
                      </p>
                      <p className={style['stat-label']}>Views</p>
                    </div>
                    <div className={`col-4 ${style.stat}`}>
                      <p className={style['stat-value']}>
                        {this.formatStat(this.total(questions, 'shares'))}
                      </p>
                      <p className={style['stat-label']}>Shares</p>
                    </div>
                    <div className={`col-4 ${style.stat}`}>
                      <p className={style['stat-value']}>
                        {this.formatStat(this.total(questions, 'followers'))}
                      </p>
                      <p className={style['stat-label']}>Followers</p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className={`col-4 ${style.stat}`}>
                      <p className={style['stat-value']}>
                        {this.formatStat(this.total(answers, 'views'))}
                      </p>
                      <p className={style['stat-label']}>Views</p>
                    </div>
                    <div className={`col-4 ${style.stat}`}>
                      <p className={style['stat-value']}>
                        {this.formatStat(this.total(answers, 'upvotes'))}
                      </p>
                      <p className={style['stat-label']}>Upvotes</p>
                    </div>
                    <div className={`col-4 ${style.stat}`}>
                      <p className={style['stat-value']}>
                        {this.formatStat(this.total(answers, 'shares'))}
                      </p>
                      <p className={style['stat-label']}>Shares</p>
                    </div>
                  </>
                )}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

StatsMain.propTypes = {
  periodOption: PropTypes.string.isRequired,
  categoryOption: PropTypes.string.isRequired,
};

export default StatsMain;
